"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";
import { Card, CardFooter, CardHeader } from "@/components/ui/card";

import { CircleCheck } from "lucide-react";

import { cn } from "@/lib/utils";

export function StakingCard({
  img,
  cryptoName,
  cryptoSymbol,
  percentage,
  selected,
  onSelectedChange,
}: {
  img: string;
  cryptoName: string;
  cryptoSymbol: string;
  percentage: number;
  selected: boolean;
  onSelectedChange: () => void;
}) {
  return (
    <Card className="h-max w-full bg-transparent">
      <CardHeader className="flex-row gap-3 space-y-0">
        <div className="bg-accent grid size-10 place-items-center rounded-lg">
          <Image
            src={img}
            alt={cryptoSymbol}
            className="h-6 w-6"
            width={256}
            height={256}
          />
        </div>
        <div className="space-y-0.5">
          <div className="text-sm font-medium text-white">
            {cryptoName}&nbsp;
            <span className="text-foreground">({cryptoSymbol})</span>
          </div>
          <div className="text-success text-xs font-normal">
            {percentage}%&nbsp;APR
          </div>
        </div>
      </CardHeader>
      <CardFooter className="px-[3px] pb-[3px]">
        <Button
          size="sm"
          onClick={onSelectedChange}
          className={cn(
            "text-primary-foreground w-full rounded-t-[3px] rounded-b-[9px]",
            {
              "bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground":
                !selected,
            },
          )}
          aria-label="Stake now"
        >
          {selected ? (
            <CircleCheck className="text-primary-foreground size-4" />
          ) : (
            "Stake Now"
          )}
        </Button>
      </CardFooter>
    </Card>
  );
}
